import React from 'react';
import { Link } from 'react-router-dom';
import { User, Search, Trophy, MapPin, ArrowRight, Shield } from 'lucide-react';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';

const STEPS = [
  { Icon: User, title: '1. Create your profile', body: 'Tell us your goals and what you want to learn. Takes under a minute.' },
  { Icon: Search, title: '2. Find a professional coach', body: 'Browse coaches in your area, see their credentials, ratings, and rates.' },
  { Icon: MapPin, title: '3. Pick a time and place', body: 'Choose a slot from the coach\u2019s availability. They come to you, or you can elect to meet them. Whatever is more convenient.' },
  { Icon: Shield, title: '4. Pay securely in-app', body: 'Card is authorized when you book. You\u2019re only charged once the coach accepts.' },
  { Icon: Trophy, title: '5. Train and earn belts', body: 'Every session counts toward your DojoDash belt progression in your chosen discipline.' },
];

const HowItWorks = () => {
  return (
    <div className="min-h-screen bg-[#09090B] py-12 px-4 sm:px-6 lg:px-8">
      <SEO
        title="How DojoDash Works | Mobile Training, On Your Schedule"
        description="See how DojoDash connects you with professional coaches who come to you. Five steps from sign-up to your first private session."
      />
      <div className="max-w-3xl mx-auto">
        <p className="text-xs uppercase tracking-[0.25em] text-[#C0A062] font-semibold mb-3">How It Works</p>
        <h1 className="text-3xl sm:text-5xl font-bold text-white leading-tight mb-10">
          A coach at your door, in five steps.
        </h1>

        <ol className="space-y-6">
          {STEPS.map(({ Icon, title, body }) => (
            <li key={title} className="flex gap-4 bg-[#18181B] border border-zinc-800 rounded-lg p-5">
              <div className="w-10 h-10 rounded-md bg-[#C0A062]/10 border border-[#C0A062]/40 flex items-center justify-center shrink-0">
                <Icon className="w-5 h-5 text-[#C0A062]" />
              </div>
              <div>
                <p className="text-white font-semibold">{title}</p>
                <p className="text-sm text-zinc-400 mt-1">{body}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-10 flex flex-col sm:flex-row gap-3">
          <Link to="/find-trainer" className="flex-1">
            <Button className="w-full bg-[#C0A062] text-black hover:bg-[#a98a52] font-semibold py-6 text-base">
              Find a coach
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
          <Link to="/become-a-trainer" className="flex-1">
            <Button variant="outline" className="w-full border-zinc-700 text-zinc-300 hover:bg-zinc-800 py-6 text-base">
              I&apos;m a coach
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
